<template>
	<section class="container">
		<div class="lay">
			<popup @close="closePopup">
				<div class="frame">
					<div class="frame-label">Авторизация</div>
					<login @submit="submit"></login>
					<agreement></agreement>
				</div>
			</popup>
		</div>
	</section>
</template>

<script>
import login from '@/components/login.vue';
import agreement from '@/components/agreement.vue';

export default {
	components: { agreement, login },
	async fetch({ store, route }) {
		return await store.dispatch('init', { route });
	},
	methods: {
		submit(data) {
			this.$store
				.dispatch('api/send', {
					task: 'login',
					data,
				})
				.then(result => {
					if (this.$store.state.user.id) {
						this.$store.dispatch('checkPromo', this.$route);
						this.$router.push(this.$store.state.lastPath);
					}
				});
		},
		closePopup() {
			//$router.back();
			document.location = '/';
		},
	},
};
</script>
